
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Emit } from 'vue-property-decorator';
import CPRadioGroup from '@/components/open-account/input/CPRadioGroup.vue';
import CPLoader from '../globals/CPLoader.vue';
import CPSubmitIndicator from '../globals/CPSubmitIndicator.vue';
import { validate, formatValidationMessages } from '@/validation';
import {
  KYCDocumentSchema,
} from '@/store/kycs/schema';

@Component({
  components: {
    CPRadioGroup,
    CPLoader,
    CPSubmitIndicator,
  },
  props: ['isCustomNeeded'],
})
export default class CPKYC extends Vue {

  public isCustomNeeded: boolean | false = this.$props.isCustomNeeded ?? false;

  public amountAnnualDisposable: string | null = null;
  public isAccountCheckedNaturalPerson: boolean | false = false;
  public isSourceIncomeOptionSalary: boolean | false = false;
  public isSourceIncomeOptionSales: boolean | false = false;
  public isSourceIncomeOptionOthers: boolean | false = false;

  public sourceOfFundsSelfEmployed: string | null = null;
  public sourceOfFundsPrevious: string | null = null;

  public sourceOfFundsProceedSalesFinancialInvestmentProceeds: string | null = null;
  public sourceOfFundsProceedSalesPropertiesProceeds: string | null = null;
  public sourceOfFundsProceedSalesSaleOfCompanyProceeds: string | null = null;
  public sourceOfFundsProceedSalesOtherSalesProceeds: string | null = null;

  public sourceOfFundsProceedSalesFinancialInvestmentRemarks: string | null = null;
  public sourceOfFundsProceedSalesPropertiesRemarks: string | null = null;
  public sourceOfFundsProceedSalesSaleOfCompanyRemarks: string | null = null;
  public sourceOfFundsProceedSalesOtherSalesRemarks: string | null = null;
  public sourceOfFundsOtherInsurancePayout: string | null = null;
  public sourceOfFundsOtherInheritance: string | null = null;
  public sourceOfFundsOtherDonation: string | null = null;
  public sourceOfFundsOtherCompensation: string | null = null;
  public sourceOfFundsOtherRentalIncome: string | null = null;
  public sourceOfFundsOtherGainFromShareholding: string | null = null;
  public sourceOfFundsOtherBusinessActivity: string | null = null;
  public sourceOfFundsOtherRetirement: string | null = null;
  public sourceOfFundsOtherOther: string | null = null;

  public IsUSPerson: boolean | false = false;
  public IsDeclaredNaturalPerson: boolean | false = false;
  public remarks: string | null = null;

  public isProceedSalesFinancial: boolean | false = false;
  public isProceedSalesProperties: boolean | false = false;
  public isProceedSalesOfCompany: boolean | false = false;
  public isProceedSalesOthers: boolean | false = false;

  public isOthersInsurance: boolean | false = false;
  public isOthersInheritance: boolean | false = false;
  public isOthersDonation: boolean | false = false;
  public isOthersCompensation: boolean | false = false;
  public isOthersRental: boolean | false = false;
  public isOthersBusiness: boolean | false = false;
  public isOthersShareholding: boolean | false = false;
  public isOthersRetirement: boolean | false = false;
  public isOthersOthers: boolean | false = false;

  public isFormValidated: boolean | false = false;
  public activeSourceFund1Category: boolean | false = false;
  public activeSourceFund2Category: boolean | false = false;
  public activeSourceFund3Category: boolean | false = false;

  @Emit('add')
  public add(): void { /* add */ }


  public close() {
    this.$store.commit('toggleKYCModal', false);
  }

  get isOthersFormValid() {
    return !this.isSourceIncomeOptionOthers ||
          this.isOthersInsurance || this.isOthersInheritance || this.isOthersDonation ||
          this.isOthersCompensation || this.isOthersRental || this.isOthersBusiness ||
          this.isOthersShareholding || this.isOthersRetirement || this.isOthersOthers;
  }

  get isSalesFormValid() {
    return !this.isSourceIncomeOptionSales ||
          (this.isProceedSalesFinancial && this.sourceOfFundsProceedSalesFinancialInvestmentProceeds) ||
          (this.isProceedSalesProperties && this.sourceOfFundsProceedSalesPropertiesProceeds) ||
          (this.isProceedSalesOfCompany && this.sourceOfFundsProceedSalesSaleOfCompanyProceeds) ||
          (this.isProceedSalesOthers && this.sourceOfFundsProceedSalesOtherSalesProceeds);
  }

  get isSalaryFormValid() {
    return this.isSourceIncomeOptionSalary;
  }

  get isFormInvalid() {
    return (this.isSourceIncomeOptionOthers && !this.isOthersFormValid) ||
          (this.isSourceIncomeOptionSales && !this.isSalesFormValid) ||
          (this.isSourceIncomeOptionSalary && !this.isSalaryFormValid) ||
          (!this.isSourceIncomeOptionOthers && !this.isSourceIncomeOptionSales && !this.isSourceIncomeOptionSalary);
  }

  public mounted() {
    // this.$store.dispatch('getAlerts');
    this.$store.commit('setMissingDocumentIsSubmitted', false);
    if (this.$store.state.onlineDocs.onlineFormData.data != null) {
            const saved = this.$store.state.onlineDocs.onlineFormData.data;

            if (saved.CheckBox_0_24999_EUR) {
              this.amountAnnualDisposable = '< 24999';
            }
            if (saved.CheckBox_25000_49999_EUR) {
              this.amountAnnualDisposable = '< 49999';
            }
            if (saved.CheckBox_50000_99999_EUR) {
              this.amountAnnualDisposable = '< 99999';
            }
            if (saved.CheckBox_100000_149999_EUR) {
              this.amountAnnualDisposable = '< 149999';
            }
            if (saved.CheckBox_150000_EUR) {
              this.amountAnnualDisposable = '< 150000';
            }

            if (saved.AmountIncome) {
              this.amountAnnualDisposable = saved.AmountIncome;
            }

            this.sourceOfFundsSelfEmployed = saved.SelfEmployed;
            this.sourceOfFundsPrevious = saved.Previous;

            if (saved.Saving || this.sourceOfFundsSelfEmployed || this.sourceOfFundsPrevious) {
              this.isSourceIncomeOptionSalary = true;
              this.activeSourceFund1Category = true;
            }

            this.sourceOfFundsProceedSalesFinancialInvestmentProceeds = saved.FinancialInvestment;
            this.sourceOfFundsProceedSalesFinancialInvestmentRemarks = saved.FinancialInvestmentRemarks;
            if (this.sourceOfFundsProceedSalesFinancialInvestmentProceeds && this.sourceOfFundsProceedSalesFinancialInvestmentRemarks) {
              this.isProceedSalesFinancial = true;
            }

            this.sourceOfFundsProceedSalesPropertiesProceeds = saved.Properties;
            this.sourceOfFundsProceedSalesPropertiesRemarks = saved.PropertiesRemarks;
            if (this.sourceOfFundsProceedSalesPropertiesProceeds && this.sourceOfFundsProceedSalesPropertiesRemarks) {
              this.isProceedSalesProperties = true;
            }

            this.sourceOfFundsProceedSalesSaleOfCompanyProceeds = saved.SaleOfCompany;
            this.sourceOfFundsProceedSalesOtherSalesProceeds = saved.OtherSales;
            if (this.sourceOfFundsProceedSalesSaleOfCompanyProceeds && this.sourceOfFundsProceedSalesOtherSalesProceeds) {
              this.isProceedSalesOfCompany = true;
            }

            this.sourceOfFundsProceedSalesSaleOfCompanyRemarks = saved.SaleOfCompanyRemarks;
            this.sourceOfFundsProceedSalesOtherSalesRemarks = saved.OtherSalesRemarks;
            if (this.sourceOfFundsProceedSalesSaleOfCompanyRemarks && this.sourceOfFundsProceedSalesOtherSalesRemarks) {
              this.isProceedSalesOthers = true;
            }

            if (this.sourceOfFundsProceedSalesFinancialInvestmentProceeds ||
            this.sourceOfFundsProceedSalesFinancialInvestmentRemarks ||
            this.sourceOfFundsProceedSalesPropertiesProceeds ||
            this.sourceOfFundsProceedSalesPropertiesRemarks ||
            this.sourceOfFundsProceedSalesSaleOfCompanyProceeds ||
            this.sourceOfFundsProceedSalesOtherSalesProceeds ||
            this.sourceOfFundsProceedSalesSaleOfCompanyRemarks ||
            this.sourceOfFundsProceedSalesOtherSalesRemarks
            ) {
              this.isSourceIncomeOptionSales = true;
            }

            if (saved.ProceedSales) {
              this.isSourceIncomeOptionSales = true;
              this.activeSourceFund2Category = true;
            }

            this.sourceOfFundsOtherInsurancePayout = saved.Insurance ?? saved.InsurancePayout;
            if (this.sourceOfFundsOtherInsurancePayout) {
              this.isOthersInsurance = true;
            }

            this.sourceOfFundsOtherInheritance = saved.Inheritance;
            if (this.sourceOfFundsOtherInheritance) {
              this.isOthersInheritance = true;
            }

            this.sourceOfFundsOtherDonation = saved.Donation;
            if (this.sourceOfFundsOtherDonation) {
              this.isOthersDonation = true;
            }

            this.sourceOfFundsOtherCompensation = saved.Compensation;
            if (this.sourceOfFundsOtherCompensation) {
              this.isOthersCompensation = true;
            }

            this.sourceOfFundsOtherRentalIncome = saved.RentalIncome;
            if (this.sourceOfFundsOtherRentalIncome) {
              this.isOthersRental = true;
            }

            this.sourceOfFundsOtherGainFromShareholding = saved.GainShareholding;
            if (this.sourceOfFundsOtherGainFromShareholding) {
              this.isOthersShareholding = true;
            }

            this.sourceOfFundsOtherBusinessActivity = saved.BusinessActivity;
            if (this.sourceOfFundsOtherBusinessActivity) {
              this.isOthersBusiness = true;
            }

            this.sourceOfFundsOtherRetirement = saved.Retirement;
            if (this.sourceOfFundsOtherRetirement) {
              this.isOthersRetirement = true;
            }

            this.sourceOfFundsOtherOther = saved.FundsOther;
            if (this.sourceOfFundsOtherOther) {
              this.isOthersOthers = true;
            }

            if (this.sourceOfFundsOtherOther ||
            this.sourceOfFundsOtherRetirement ||
            this.sourceOfFundsOtherBusinessActivity ||
            this.sourceOfFundsOtherGainFromShareholding ||
            this.sourceOfFundsOtherRentalIncome ||
            this.sourceOfFundsOtherCompensation ||
            this.sourceOfFundsOtherDonation ||
            this.sourceOfFundsOtherInheritance ||
            this.sourceOfFundsOtherInsurancePayout) {
              this.isSourceIncomeOptionOthers = true;
            }

            if (saved.Other) {
              this.isSourceIncomeOptionOthers = true;
              this.activeSourceFund3Category = true;
            }

            // IsUSPerson: true = "not a US person" (CPRadioGroup). CheckBox_IsUSPerson was stored with inverted meaning in older saves.
            this.IsUSPerson = typeof saved.USPerson === 'boolean'
              ? saved.USPerson
              : (saved.CheckBox_IsUSPerson as boolean) ?? false;
            this.IsDeclaredNaturalPerson = typeof saved.DeclaredNaturalPerson === 'boolean'
              ? saved.DeclaredNaturalPerson
              : saved.CheckBox_DeclaredNaturalPerson ?? false;
            this.remarks = saved.Remarks;
        }
  }

  public validateDecimalNumber(event: any) {
    const inputValue = event.target.value + event.key;
    if (inputValue?.includes('.') && !inputValue?.split('.')?.[1]) {
      return;
    }
    if (event.key.length > 1) {
      return false;
    }
    if (!/^-?\d+\.{0,1}?\d{0,3}$/.test(inputValue)) {
      event.target.value = parseFloat(event.target.value).toFixed(2).toString();
      event.preventDefault();
    }
    return true;
  }

  public async submit() {
    const kycFormData = {
      AmountIncome: this.amountAnnualDisposable,
      Saving: this.isSourceIncomeOptionSalary,
      ProceedSales: this.isSourceIncomeOptionSales,
      Other: this.isSourceIncomeOptionOthers,
      SelfEmployed: this.sourceOfFundsSelfEmployed,
      Previous: this.sourceOfFundsPrevious,
      FinancialInvestment: this.sourceOfFundsProceedSalesFinancialInvestmentProceeds,
      Properties: this.sourceOfFundsProceedSalesPropertiesProceeds,
      SaleOfCompany: this.sourceOfFundsProceedSalesSaleOfCompanyProceeds,
      OtherSales: this.sourceOfFundsProceedSalesOtherSalesProceeds,
      FinancialInvestmentRemarks: this.sourceOfFundsProceedSalesFinancialInvestmentRemarks,
      PropertiesRemarks: this.sourceOfFundsProceedSalesPropertiesRemarks,
      SaleOfCompanyRemarks: this.sourceOfFundsProceedSalesSaleOfCompanyRemarks,
      OtherSalesRemarks: this.sourceOfFundsProceedSalesOtherSalesRemarks,
      InsurancePayout: this.sourceOfFundsOtherInsurancePayout,
      Inheritance: this.sourceOfFundsOtherInheritance,
      Donation: this.sourceOfFundsOtherDonation,
      Compensation: this.sourceOfFundsOtherCompensation,
      RentalIncome: this.sourceOfFundsOtherRentalIncome,
      GainShareholding: this.sourceOfFundsOtherGainFromShareholding,
      BusinessActivity: this.sourceOfFundsOtherBusinessActivity,
      Retirement: this.sourceOfFundsOtherRetirement,
      FundsOther: this.sourceOfFundsOtherOther,
      USPerson: this.IsUSPerson,
      DeclaredNaturalPerson: this.IsDeclaredNaturalPerson,
      Remarks: this.remarks,
    };

    const validation = validate(
      kycFormData,
      KYCDocumentSchema,
    );

    if (validation.error) {
      const errArr: string[] = formatValidationMessages(
        validation.error.details,
      );
      this.$store.commit('addError',
        errArr[0]);
    } else {

      this.$store.commit('setMissingDocumentIsSubmitting', true);
      this.$store.commit('setMissingDocumentIsSubmitted', false);
      setTimeout(async () => {
        await this.$store.dispatch('submitKYCDocument', { missingDocumentId: this.$store.state.missingDocument.ID, data: kycFormData, whiteLabelId: this.$store.state.account.details.whiteLabelId });
        this.$store.commit('setMissingDocumentIsSubmitting', false);
        this.$store.commit('setMissingDocumentIsSubmitted', true);

        setTimeout(async () => {
          this.$store.commit('toggleKYCModal', false);
          setTimeout(async () => {
                    this.$store.commit('setMissingDocumentIsSubmitted', false);
          }, 300);

        }, 1000);
      }, 1000);
    }



  }
}
